import React, { useEffect, useState } from "react";
import Left_menu from './Left_menu'
import Header from './Header'
import config from "../../config"
import axios from 'axios'
const ShopifyConnect = () => {
    const [storeId, setStoreId] = useState("");
    const [installUrl, setInstallUrl] = useState("");
    const [shop, setShop] = useState("");
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        const homeSection = document.querySelector('.home-section');
        if (homeSection) {
            homeSection.classList.toggle('sidebar-closed');
        }
    };
  
    useEffect(() => {
      // Generate store ID
      const randomStoreId = String(
        Math.floor(1000000000 + Math.random() * 9000000000)
      );
      setStoreId(randomStoreId);
  
      // Get shop from callback redirect
      const params = new URLSearchParams(window.location.search);
      const shopParam = params.get("shop");
      if (shopParam) {
        setShop(shopParam);
        handleFinalConnect(shopParam, randomStoreId);
      }
    }, []);
  
    const handleInstall = async () => {
      if (!installUrl) {
        alert("Please paste the Shopify Install URL");
        return;
      }
  
      try {
        const res = await axios.post(
          "https://backend.mojoship.in/auth/preConnect",
          { install_url: installUrl },
          { headers: config.headers }
        );
  
        window.location.href = res.data;
      } catch (err) {
        console.error(err);
      }
    };
  
    const handleFinalConnect = async (shop, storeId) => {
      const userDetail = localStorage.getItem("ship_rocket_user");
  
      // 🔐 If not logged in
      if (!userDetail) {
        window.location.href = `/customer/login?redirect=shopify-connect&shop=${shop}`;
        return;
      }
  
      const userData = JSON.parse(userDetail);
  
      try {
        const res = await axios.post(
          "https://backend.mojoship.in/auth/finalConnect",
          {
            shop,
            store_id: storeId,
            customer_id: userData.customer_id,
          },
          { headers: config.headers }
        );
  
        if (res.data.status === "success") {
          window.location.href =
            "https://app.mojoship.in/customer/channel_list?status=success";
        } else if (res.data.status === "already_connected") {
          window.location.href =
            "https://app.mojoship.in/customer/channel_list?status=already_connected";
        }
      } catch (err) {
        console.error(err);
      }
    };

  return (
    <div>
       
          
         <Left_menu isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      
      <div className="home-section">
         
          <Header/>

    
    <div style={{  padding: 24 }}>
      <h2>Connect Shopify Store</h2>

      <p>
        Follow the steps below carefully to connect your Shopify store with
        Mojoship. This is a one-time setup.
      </p>

      <hr />

      {/* STEP 1 */}
      <h3>Step 1: Login to Shopify Partner Dashboard</h3>
      <ol>
        <li>
          Open{" "}
          <a
            href="https://partners.shopify.com"
            target="_blank"
            rel="noreferrer"
          >
            https://partners.shopify.com
          </a>
        </li>
        <li>Login using your Shopify account</li>
      </ol>

      <hr />

      {/* STEP 2 */}
      <h3>Step 2: Create a Custom App</h3>
      <ol>
        <li>Go to <b>App Distribution → All apps</b></li>
        <li>Click <b>Visit Dev dashboard</b></li>
        <li>Click <b>Create app</b></li>
        <li>Enter app name (example: <b>Mojoship Integration</b>)</li>
        <li>
          In <b>App URL</b>, enter:
          <br />
          <code>https://backend.mojoship.in/auth/callback</code>
        </li>
        <li>Uncheck Embed app in Shopify admin</li>
        <li> In <b>Access → Scopes</b>, enter:<br/>
        <code>write_assigned_fulfillment_orders, read_assigned_fulfillment_orders, write_draft_orders, read_draft_orders, write_fulfillments, read_fulfillments, write_merchant_managed_fulfillment_orders, read_merchant_managed_fulfillment_orders, write_inventory, read_inventory, write_orders, read_orders, write_products, read_products, write_product_listings, read_product_listings, write_product_feeds, read_product_feeds</code>
        </li>

        <li>Scroll down and click on Release</li>
      </ol>

      <hr />

      {/* STEP 3 */}
      <h3>Step 3: Configure App Distribution</h3>
      <ol>
        <li>Open your created app</li>
        <li>Click on Home</li>
        <li>Click <b>Distribution → Select distribution method</b></li>
        <li>Select <b>Custom Distribution</b></li>
        <li>Click <b>Select</b></li>
        <li>A dialogue will open of Select custom distribution?</li>
        <li>Click <b>Select custom distribution</b></li>
        <li>
          Enter your store URL:
          <br />
          <code>yourstore.myshopify.com</code>
        </li>
        <li>Click <b>Generate Link</b></li>
        <li>
          Shopify will generate an <b>Install URL</b>
        </li>
      </ol>

      <hr />

      {/* STEP 4 */}
     

      <hr />

      {/* STEP 5 */}
      <h3>Step 4: Install the App</h3>
      <p>
        Copy the <b>Install URL</b> generated by Shopify and paste it below:
      </p>

      <input
        type="text"
        value={installUrl}
        onChange={(e) => setInstallUrl(e.target.value)}
        placeholder="https://admin.shopify.com/oauth/install_custom_app?client_id=..."
        style={{ width: "100%", padding: 8 }}
        className="form-control"
      />

      <br />

      <button className="btn btn-primary" onClick={handleInstall}>
        Install Shopify App
      </button>

      <hr />
    
                                                     
       
      

      {/* INFO */}
      {/* <p>
        <b>Generated Store ID:</b> {storeId}
      </p> */}

      <p style={{ color: "#555" }}>
        Note:
        <br />
        • You do NOT need to share API key or secret  
        <br />
        • No Admin API token is required  
        <br />
        • Orders are synced securely via webhooks  
      </p>
    </div>
    </div>
    </div>
    
  );
};

export default ShopifyConnect;
